"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_toast_notifications_1 = require("react-toast-notifications");
var query_string_1 = __importDefault(require("query-string"));
var ToastMessageHandler_1 = __importDefault(require("./components/ToastMessageHandler/ToastMessageHandler"));
var AppHeader_1 = __importDefault(require("./components/AppHeader/AppHeader"));
var MobileMenu_1 = __importDefault(require("./components/Mobile/MobileMenu"));
var Layout_1 = __importDefault(require("./Layout"));
var SubscriptionPlanModal_1 = __importDefault(require("./components/SubscriptionPlanModal"));
var auth_1 = require("./helpers/auth");
var LoginForm_1 = __importDefault(require("./features/login/LoginForm"));
var searchParamsSlice_1 = require("./features/searchParams/searchParamsSlice");
var userSlice_1 = require("./features/user/userSlice");
var currencySlice_1 = require("./features/currencies/currencySlice");
function App() {
    var _a = react_1.useState(false), open = _a[0], setMobileMenu = _a[1];
    var mobileOpen = react_1.useCallback(function () {
        setMobileMenu(!open);
    }, [open]);
    var dispatch = react_redux_1.useDispatch();
    var token = react_redux_1.useSelector(function (state) { return state.login.token; });
    react_1.useLayoutEffect(function () {
        var queryParams = query_string_1.default.parse(window.location.search);
        if (queryParams.token) {
            auth_1.setToken(queryParams.token);
            dispatch(userSlice_1.getMyProfile());
            auth_1.setIsFavoriteUser(!!queryParams.token);
        }
        else {
            auth_1.removeIsFavoriteUser();
        }
    }, []);
    react_1.useEffect(function () {
        dispatch(searchParamsSlice_1.getFilterSchema());
        // @TODO need to check if need this request of plans!
        // dispatch(getSubscriptionPlans());
        dispatch(currencySlice_1.fetchExchangeRates());
    }, []);
    react_1.useEffect(function () {
        if (token) {
            dispatch(userSlice_1.getMyProfile());
        }
    }, [token]);
    react_1.useEffect(function () {
        // If user logs out/in in a different tab, reload in order to reflect the changes
        window.addEventListener('storage', function (e) {
            if (e.key === auth_1.TOKEN) {
                if (e.newValue === null || e.oldValue === null) {
                    window.location.reload();
                }
            }
        });
    }, []);
    return (react_1.default.createElement(react_toast_notifications_1.ToastProvider, null,
        react_1.default.createElement(LoginForm_1.default, null),
        react_1.default.createElement(SubscriptionPlanModal_1.default, null),
        react_1.default.createElement(MobileMenu_1.default, { open: open, mobileOpen: mobileOpen }),
        react_1.default.createElement(AppHeader_1.default, { ToggleMobileMenu: mobileOpen }),
        react_1.default.createElement(Layout_1.default, null),
        react_1.default.createElement(ToastMessageHandler_1.default, null)));
}
exports.default = App;
